export const WATCH_LEVELS = [
  {
    id: 0,
    key: 'new',
    shortLabel: 'L0',
    label: '0 - новые добавленные / без модерации'
  },
  {
    id: 1,
    key: 'light',
    shortLabel: 'L1',
    label: '1 - можно снимать, но не много'
  },
  {
    id: 2,
    key: 'often',
    shortLabel: 'L2',
    label: '2 - снимать чаще'
  },
  {
    id: 3,
    key: 'clients',
    shortLabel: 'L3',
    label: '3 - постоянные клиенты'
  },
  {
    id: 4,
    key: 'order',
    shortLabel: 'L4',
    label: '4 - заказ'
  },
  {
    id: 5,
    key: 'artmaster',
    shortLabel: 'LA',
    label: 'LA - Артмастер'
  }
]

const WATCH_LEVEL_SET = new Set(WATCH_LEVELS.map(i => i.id))

export const normalizeWatcherLevel = value => {
  const n = Number(value)
  if (WATCH_LEVEL_SET.has(n)) return n
  return 0
}

export const getWatchLevelMeta = value => {
  const level = normalizeWatcherLevel(value)
  return WATCH_LEVELS.find(i => i.id === level) || WATCH_LEVELS[0]
}

export const getWatchLevelWeight = value => normalizeWatcherLevel(value)
